module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Activate Return-Shop")]), _vm._v(" "), _c('v-stepper', {
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.cur),
      callback: function($$v) {
        _vm.cur = $$v
      },
      expression: "cur"
    }
  }, [_c('v-stepper-step', {
    attrs: {
      "step": "1",
      "complete": _vm.cur > 1,
      "editable": ""
    }
  }, [_vm._v("\n            Select Customer\n\n            "), (_vm.customer) ? _c('small', [_vm._v("\n                " + _vm._s(_vm.customer.customerName1) + " " + _vm._s(_vm.customer.customerName2) + " " + _vm._s(_vm.customer.customerName3) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "search-input": _vm.customerSearchInput,
      "item-text": "customerName1",
      "item-value": "id",
      "filled": "",
      "items": _vm.customerAutocompleteData,
      "return-object": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.customerSearchInput = $event
      },
      "update:search-input": function($event) {
        _vm.customerSearchInput = $event
      }
    },
    model: {
      value: (_vm.customer),
      callback: function($$v) {
        _vm.customer = $$v
      },
      expression: "customer"
    }
  }), _vm._v(" "), (_vm.customer) ? _c('v-btn', {
    attrs: {
      "block": "",
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateCustomer()
      }
    }
  }, [_vm._v("Next")]) : _vm._e()], 1), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "2",
      "editable": ""
    }
  }, [_vm._v("\n            Branding\n\n            "), (_vm.brandName) ? _c('small', [_vm._v("\n              " + _vm._s(_vm.brandName) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "pb-4",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs16": ""
    }
  }, [_c('v-text-field', {
    ref: "step1_text-field",
    attrs: {
      "prepend-icon": "http",
      "rules": [_vm.rules.required, _vm.rules.greater3, _vm.rules.sanitized],
      "counter": "50",
      "filled": "",
      "label": "Identifier",
      "placeholder": "Enter here the identifier of your return shop",
      "hint": _vm.consumerAppUrlPreview(_vm.identifier),
      "persistent-hint": "",
      "id": "testing",
      "error": false,
      "error-messages": _vm.identifierErrorArr
    },
    on: {
      "input": _vm.checkIndentifierAvailbility
    },
    model: {
      value: (_vm.dirtyIdentifier),
      callback: function($$v) {
        _vm.dirtyIdentifier = $$v
      },
      expression: "dirtyIdentifier"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs16": ""
    }
  }, [_c('v-text-field', {
    ref: "step3_text-field",
    attrs: {
      "prepend-icon": "business",
      "rules": [_vm.rules.required, _vm.rules.greater3],
      "label": "Brand Name",
      "filled": "",
      "placeholder": "This is the name of your brand which will be used in Text-Modules in the App and in E-Mails.",
      "id": "testing"
    },
    model: {
      value: (_vm.brandName),
      callback: function($$v) {
        _vm.brandName = $$v
      },
      expression: "brandName"
    }
  })], 1)], 1), _vm._v(" "), (_vm.identifier && _vm.brandName && !_vm.hasError) ? _c('v-btn', {
    attrs: {
      "block": "",
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateBranding()
      }
    }
  }, [_vm._v("Next")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "3"
    }
  }, [_vm._v("Configuration")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [_c('isrs-parcel-number-select', {
    attrs: {
      "parcelnumbercontainers": _vm.parcelnumbercontainers
    },
    on: {
      "change": function (id) { return _vm.updateParcelNumberContainerId(id); }
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Country Mappings")]), _vm._v(" "), _c('div', [_vm._l((_vm.contacts), function(contact) {
    return _c('v-layout', {
      key: contact.contactId,
      attrs: {
        "ma-2": "",
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs8": ""
      }
    }, [_c('v-select', {
      attrs: {
        "items": _vm.countries,
        "label": "Customers from these countries:",
        "item-text": "name",
        "item-value": "alpha2",
        "multiple": ""
      },
      model: {
        value: (_vm.countriesSelected[contact.contactId]),
        callback: function($$v) {
          _vm.$set(_vm.countriesSelected, contact.contactId, $$v)
        },
        expression: "countriesSelected[contact.contactId]"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "ml-4": ""
      }
    }, [_c('small', {
      staticClass: "grey--text text--darken-2"
    }, [_vm._v("send returns to this contact:")]), _vm._v(" "), _c('div', [_vm._v("\n                  Contact ID:"), _c('b', [_vm._v(" " + _vm._s(contact.contactId))])]), _vm._v(" "), _c('hr', {
      staticStyle: {
        "height": "1px",
        "border": "none",
        "background-color": "grey"
      }
    }), _vm._v(" "), _c('div', [_c('b', [_vm._v(_vm._s(contact.contactText1) + " " + _vm._s(contact.contactText2) + " " + _vm._s(contact.contactText3))])]), _vm._v(" "), _c('div', [_c('i', [_vm._v(_vm._s(contact.street))])]), _vm._v(" "), _c('div', [_c('i', [_vm._v(_vm._s(contact.zipcode) + " " + _vm._s(contact.city))])])])], 1)
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "ma-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n                The following countries are not mapped and therefore customers from these countries can not send a return to this customer:\n                "), _c('span', [_vm._v("\n                  " + _vm._s(_vm.notMappedCountries.map(function (c) { return c.name; }).join(", ")) + "\n                ")])])], 1)], 2), _vm._v(" "), (_vm.payload && !_vm.publishError) ? _c('v-btn', {
    attrs: {
      "block": "",
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.publishReturnShop()
      }
    }
  }, [_vm._v("Publish")]) : _vm._e(), _vm._v(" "), (this.publishError.length > 1) ? _c('v-alert', {
    attrs: {
      "type": "error"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.publishError) + "\n            ")]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-loader/lib/template-compiler?{"id":"data-v-317ba6e2"}!/export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-loader/lib/selector.js?type=template&index=0!./client/views/returnShopPortals/Activate.vue
// module id = 928
// module chunks = 1